/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

import defaultPlaceholderComponents from './defaultPlaceholderComponents';

import styles from '../styles/draggableListItemPlaceholder.module.scss';

const DraggableListItemPlaceholder = ({
  components = defaultPlaceholderComponents,
  customStyles = {},
  placeholderProps = {},
}) => {
  const {
    clientY: top,
    clientX: paddingLeft,
    clientWidth: width,
    clientHeight: height,
    clientItem,
  } = placeholderProps;

  const { Content } = { ...defaultPlaceholderComponents, ...components };

  return (
    <div
      className={styles.element}
      style={{
        ...customStyles,
        top,
        paddingLeft,
        width,
        height,
      }}
    >
      <div>
        <Content item={clientItem} />
      </div>
    </div>

  );
};

DraggableListItemPlaceholder.propTypes = {
  placeholderProps: PropTypes.shape({
    clientY: PropTypes.number,
    clientX: PropTypes.number,
    clientWidth: PropTypes.number,
    clientHeight: PropTypes.number,
    clientItem: PropTypes.shape({
      data: PropTypes.shape({
        title: PropTypes.string,
      }),
    }),
  }),
  customStyles: PropTypes.objectOf(PropTypes.string),
  components: PropTypes.shape({}),
};

export default React.memo(DraggableListItemPlaceholder);
